const FormFields = {
  maintenance: {
    id: 'maintenance-controls',
    name: 'maintenanceEnabled',
    ariaDescribedBy: 'maintenance-helper-text',
    trueLabel: 'ON',
    falseLabel: 'OFF',
    value: '',
    description: "Select 'ON' to enable maintenance mode, which will display a maintenance page to all users. Select 'OFF' to disable maintenance mode and allow normal access to the application.",
  },
};

export const DefaultValues = {
  [FormFields.maintenance.name]: 'False',
};
export default FormFields;
